var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-message-alert",class:{'show' : _vm.isShown}},[_c('img',{attrs:{"src":"/main/img/icons/check.svg"}}),_vm._v(" "+_vm._s(_vm.trans('message_copied',{issue: this.type === 'image' ? _vm.trans('photo') : _vm.trans('message')}))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }